function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "fishselected",
  transform: "translate(-32.836 -46.708)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M0,82.666Z",
  transform: "translate(45.342 45.342)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_15",
  "data-name": "Group 15",
  transform: "translate(76.756 46.708)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_42",
  "data-name": "Path 42",
  d: "M307.177,93.411h-22a89.423,89.423,0,0,0-89.423,89.423v22h22a89.423,89.423,0,0,0,89.423-89.423Z",
  transform: "translate(-174.625 -93.411)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M214.751,123.036s-37.476-.154-61.249,23.618c0,0,19.733,2.377,29.828,12.471",
  transform: "translate(-153.502 -108.223)",
  fill: "#65ccb8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_16",
  "data-name": "Group 16",
  transform: "translate(32.836 46.708)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44",
  "data-name": "Path 44",
  d: "M301.075,93.411h-15.9a89.423,89.423,0,0,0-89.423,89.423v22h15.9v-22A89.423,89.423,0,0,1,301.075,93.411Z",
  transform: "translate(-130.706 -93.411)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M134.461,308.754v22a88.905,88.905,0,0,1-13.212,46.788v0a67.134,67.134,0,0,0-55.58-55.584h0a88.959,88.959,0,0,1,46.788-13.205h22Z",
  transform: "translate(-65.668 -201.076)",
  fill: "#65ccb8"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_41",
  "data-name": "Ellipse 41",
  cx: 7.429,
  cy: 7.429,
  r: 7.429,
  transform: "translate(158.756 69.656)",
  fill: "#65ccb8"
}));

function SvgFishselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.471,
    height: 176.47,
    viewBox: "0 0 176.471 176.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishselected);
export default __webpack_public_path__ + "static/media/fishselected.71d81287.svg";
export { ForwardRef as ReactComponent };